import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

const getUser = (userId: number) => {
  const path = Routes.user_profile_light_path(userId);

  return axios
    .get(path)
    .then(({ data }) => ({ avatar: data.user.profilePicture, ...data.user }));
};

const useGetUserInformation = (userId: number) =>
  useQuery({
    queryKey: ['user-snapshot', userId],
    queryFn: () => {
      if (!userId) {
        throw new Error('userId is required to fetch user information');
      }
      return getUser(userId);
    },
    enabled: false,
    staleTime: ms('5m'),
  });

export default useGetUserInformation;
